import React, {useEffect, useState} from 'react';
import {useTranslation} from "react-i18next";
import {IonCol, IonRow} from "@ionic/react";
import Modal from "@components/modal/modal.component";
import {StyledTextarea} from "@components/form/input/textarea.style";
import {StyledIonLabel} from "@components/form/input/label.style";
import {StyledButton, StyledWiteButton} from "@components/button/button.style";

type ProposalRejectModalProps = {
    isOpen: boolean;
    submitting?: boolean;
    onClose: () => void;
    onConfirm: (reason: string, replacement: string | null) => void;
};

const ProposalRejectModal: React.FC<ProposalRejectModalProps> = ({isOpen, submitting = false, onClose, onConfirm}: ProposalRejectModalProps) => {
    const {t} = useTranslation();

    const [reason, setReason] = useState<string>('');
    const [replacement, setReplacement] = useState<string>('');

    useEffect(() => {
        if (isOpen) {
            setReason('');
            setReplacement('');
        }
    }, [isOpen]);

    const handleConfirm = () => {
        if (submitting) {
            return;
        }

        onConfirm(reason.trim(), replacement.trim() || null);
    };

    return (
        <Modal initialBreakpoint={0.99} breakpoints={[0, 0.99]} isOpen={isOpen} onDidDismiss={() => onClose()}>
            <h1 className="title">{t('availability.proposal.reject.title')}</h1>
            <IonRow>
                <IonCol size="12">
                    <StyledIonLabel className="ion-text-wrap" style={{margin: '8px 0 4px'}}>
                        {t('availability.proposal.reject.reason')} ({t('availability.proposal.reject.optional')})
                    </StyledIonLabel>
                </IonCol>
                <IonCol size="12">
                    <StyledTextarea
                        className="full-width small resize-none"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder={t('availability.proposal.reject.reasonPlaceholder')}
                    />
                </IonCol>
                <IonCol size="12">
                    <StyledIonLabel className="ion-text-wrap" style={{margin: '8px 0 4px'}}>
                        {t('availability.proposal.reject.replacement')} ({t('availability.proposal.reject.optional')})
                    </StyledIonLabel>
                </IonCol>
                <IonCol size="12">
                    <StyledTextarea
                        className="full-width small resize-none"
                        value={replacement}
                        onChange={(e) => setReplacement(e.target.value)}
                        placeholder={t('availability.proposal.reject.replacementPlaceholder')}
                    />
                </IonCol>
            </IonRow>
            <IonRow style={{paddingBottom: 'var(--ion-safe-area-bottom, 0px)'}}>
                <IonCol size="6">
                    <StyledButton disabled={submitting} onClick={handleConfirm}>
                        {t('availability.proposal.reject.confirm')}
                    </StyledButton>
                </IonCol>
                <IonCol size="6">
                    <StyledWiteButton disabled={submitting} onClick={() => onClose()}>
                        {t('common.alertCancel')}
                    </StyledWiteButton>
                </IonCol>
            </IonRow>
        </Modal>
    );
};

export default ProposalRejectModal;
